import { Card } from '@mui/material';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { SmartLinksExternalButton } from './SmartLinksExternalButton';
import { SmartLinksExternalInfoContent } from './SmartLinksExternalInfo.styled';

type SmartLinksExternalInfoProps = ComponentProps<typeof SmartLinksExternalButton>;

export const SmartLinksExternalInfo = ({ href }: SmartLinksExternalInfoProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'SmartLinks' });

  return (
    <Card sx={{ width: '100%', display: 'flex' }}>
      <SmartLinksExternalInfoContent>
        <p>{t('noEmbed')}</p>
        <SmartLinksExternalButton href={href} />
      </SmartLinksExternalInfoContent>
    </Card>
  );
};
